// extracted by mini-css-extract-plugin
export var aiStarSpin = "_pq-1";
export var spinner = "_pq-0";